<form class="m-form m-form--fit m-form--label" [formGroup]="tcRuleCreationForm">
		<div class='row'>
			<div class="col-9 form-group m-form__group m--margin-top-10 form_header">
	
				Existing Training Centre Type and Fee Payment Setup Info:
			</div>
			<div class="m-portlet__head-tools col-3">
				<a class="m-portlet__nav-link btn btn-secondary pull-right blueColor" *ngIf="!isAdmin" (click)="addTrainingCentreType()" data-target="#trainingcenter_type_modal"
				 data-toggle="modal">
					Add Another Training Centre Type
				</a>
			</div>
		</div>
	
	 
		<div *ngFor="let rule of tcRuleCreationForm.get('rulesForType')['controls']; let i = index;" formArrayName="rulesForType">
			<div [formGroupName]="i">
				<div class="form-group m-form__group m--margin-top-10 form_header">
					{{i+1}}. Training Centre Type {{tcRuleDetails.rulesForType[i].type}}
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Accreditation Fee:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-4">
						<select [disabled]="isDisabled()" (ngModelChange)="setValidation($event, tcRuleCreationForm.get('rulesForType').controls[i].get('accredationAmount'))"
						 name="trainingCentre" class="form-control m-input" id="exampleSelect1" [(ngModel)]="tcRuleDetails.rulesForType[i].accredation.isPaymentRequired"
						 formControlName="accredationAmountIsRequired">
							<option value="" disabled>Select Payment Required or Not</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('accredationAmountIsRequired')"
						  [name]="'Option'"></app-form-control-messages>
					</div>
					<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[i].accredation.isPaymentRequired=='Yes'">
						<div class="col-1 col-form-label">Rs.</div>
						<div class="col-10">
							<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number" placeholder="Enter the amount needs to be paid"
							 [(ngModel)]="tcRuleDetails.rulesForType[i].accredation.amount" formControlName="accredationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							 maxlength="8" minlength="0" min="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45" min="0">
							<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('accredationAmount')"
							 [name]="'Amount'"></app-form-control-messages>
	
						</div>
					</div>
				</div>
	
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Continuous Monitoring Fee :
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-4">
						<select (ngModelChange)="setValidation($event, tcRuleCreationForm.get('rulesForType').controls[i].get('continuousMonitoringAmount'))"
						 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
						 formControlName="continuousMonitoringAmountIsRequired" [(ngModel)]="tcRuleDetails.rulesForType[i].continuousMonitoring.isPaymentRequired">
							<option value="" disabled>Select Payment Required or Not</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('continuousMonitoringAmountIsRequired')"
						  [name]="'Option'"></app-form-control-messages>
					</div>
					<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[i].continuousMonitoring.isPaymentRequired=='Yes'">
						<div class="col-1 col-form-label">Rs.</div>
						<div class="col-10">
							<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
							 placeholder="Enter the amount needs to be paid" formControlName="continuousMonitoringAmount" [(ngModel)]="tcRuleDetails.rulesForType[i].continuousMonitoring.amount"
							 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							 maxlength="8" minlength="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45" min="0">
							<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('continuousMonitoringAmount')"
							 [name]="'Amount'"></app-form-control-messages>
						</div>
					</div>
				</div>
	
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Un-Blocking Fee:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-4">
						<select (ngModelChange)="setValidation($event, tcRuleCreationForm.get('rulesForType').controls[i].get('unblockingAmount'))"
						 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
						 formControlName="unblockingAmountIsRequired" [(ngModel)]="tcRuleDetails.rulesForType[i].unBlocking.isPaymentRequired">
							<option value="" disabled>Select Payment Required or Not</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('unblockingAmountIsRequired')"
						  [name]="'Option'"></app-form-control-messages>
					</div>
					<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[i].unBlocking.isPaymentRequired=='Yes'">
						<div class="col-1 col-form-label">Rs.</div>
						<div class="col-10">
							<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
							 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[i].unBlocking.amount"
							 formControlName="unblockingAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							 maxlength="8" minlength="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45" min="0">
							<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('unblockingAmount')"
							 [name]="'Amount'"></app-form-control-messages>
						</div>
					</div>
				</div>
	
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Per-Job Role Affiliation Fee :
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-4">
						<select (ngModelChange)="setValidation($event, tcRuleCreationForm.get('rulesForType').controls[i].get('affilationAmount'))"
						 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
						 formControlName="affilationAmountIsRequired" [(ngModel)]="tcRuleDetails.rulesForType[i].perJobRoleAffiliation.isPaymentRequired">
							<option value="" disabled>Select Payment Required or Not</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('affilationAmountIsRequired')"
						  [name]="'Option'"></app-form-control-messages>
					</div>
					<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[i].perJobRoleAffiliation.isPaymentRequired=='Yes'">
						<div class="col-1 col-form-label">Rs.</div>
						<div class="col-10">
							<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
							 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[i].perJobRoleAffiliation.amount"
							 formControlName="affilationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							 maxlength="8" minlength="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45" min="0">
							<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('affilationAmount')"
							 [name]="'Amount'"></app-form-control-messages>
	
						</div>
					</div>
				</div>

				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Appeal Fee:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-4">
						<select (ngModelChange)="setValidation($event, tcRuleCreationForm.get('rulesForType').controls[i].get('appealAmount'))"
						 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
						 formControlName="appealAmountIsRequired" [(ngModel)]="tcRuleDetails.rulesForType[i].appeal.isPaymentRequired">
							<option value="" disabled>Select Payment Required or Not</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('appealAmountIsRequired')"
						  [name]="'Option'"></app-form-control-messages>
					</div>
					<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[i].appeal.isPaymentRequired=='Yes'">
						<div class="col-1 col-form-label">Rs.</div>
						<div class="col-10">
							<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
							 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[i].appeal.amount"
							 formControlName="appealAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							 maxlength="8" minlength="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45" min="0">
							<app-form-control-messages [control]="tcRuleCreationForm.get('rulesForType').controls[i].get('appealAmount')"
							 [name]="'Amount'"></app-form-control-messages>
						</div>
					</div>
				</div>
	
				<div class="row" style="margin-left: 3px;">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
					</label>
					<div class="col-4">
						<a class="text-Centre blueColor" (click)="removeTrainingCentreType(i)" *ngIf='tcRuleDetails.rulesForType.length>1'>Remove Training Centre Type</a>
					</div>
				</div>
	
	
	
			</div>
			<div class="m-form__seperator m-form__seperator--dashed" style="margin-top:5px;"></div>
		</div>
	
		<!-- 
	
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Accreditation Fee:
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select [disabled]="isDisabled()" (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.govtAccredationAmount)"
				 name="trainingCentre" class="form-control m-input" id="exampleSelect1" [(ngModel)]="tcRuleDetails.rulesForType[0].accredation.isPaymentRequired"
				 formControlName="govtAccredationAmountIsRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.govtAccredationAmountIsRequired"  [name]="'Option'"></app-form-control-messages>
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[0].accredation.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number" placeholder="Enter the amount needs to be paid"
					 [(ngModel)]="tcRuleDetails.rulesForType[0].accredation.amount" formControlName="govtAccredationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0" min="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.govtAccredationAmount" [name]="'Amount'"></app-form-control-messages>
	
				</div>
			</div>
		</div>
	
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Continuous Monitoring Fee :
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.govtContinuousMonitoringAmount)"
				 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
				 formControlName="govtContinuousMonitoringAmountIsRequired" [(ngModel)]="tcRuleDetails.rulesForType[0].continuousMonitoring.isPaymentRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.govtContinuousMonitoringAmountIsRequired"  [name]="'Option'"></app-form-control-messages>
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[0].continuousMonitoring.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
					 placeholder="Enter the amount needs to be paid" formControlName="govtContinuousMonitoringAmount" [(ngModel)]="tcRuleDetails.rulesForType[0].continuousMonitoring.amount"
					 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.govtContinuousMonitoringAmount" [name]="'Amount'"></app-form-control-messages>
				</div>
			</div>
		</div>
	
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Un-Blocking Fee:
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.govtUnblockingAmount)" [disabled]="isDisabled()"
				 name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="govtUnblockingAmountIsRequired"
				 [(ngModel)]="tcRuleDetails.rulesForType[0].unBlocking.isPaymentRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.govtUnblockingAmountIsRequired"  [name]="'Option'"></app-form-control-messages>
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[0].unBlocking.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
					 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[0].unBlocking.amount"
					 formControlName="govtUnblockingAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.govtUnblockingAmount" [name]="'Amount'"></app-form-control-messages>
				</div>
			</div>
		</div>
	
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Per-Job Role Affiliation Fee :
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.govtAffilationAmount)" [disabled]="isDisabled()"
				 name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="govtAffilationAmountIsRequired"
				 [(ngModel)]="tcRuleDetails.rulesForType[0].perJobRoleAffiliation.isPaymentRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.govtAffilationAmountIsRequired"  [name]="'Option'"></app-form-control-messages>
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[0].perJobRoleAffiliation.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
					 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[0].perJobRoleAffiliation.amount"
					 formControlName="govtAffilationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.govtAffilationAmount" [name]="'Amount'"></app-form-control-messages>
	
				</div>
			</div>
		</div>
	
	
	
	
		<div class="form-group m-form__group m--margin-top-10 form_header">
			2. Training Centre Type "Government"
		</div>
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Accreditation Fee:
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.regularAccredationAmount)"
				 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
				 formControlName="regularAccredationAmountIsRequired" [(ngModel)]="tcRuleDetails.rulesForType[1].accredation.isPaymentRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.regularAccredationAmountIsRequired"  [name]="'Option'"></app-form-control-messages>
	
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[1].accredation.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
					 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[1].accredation.amount"
					 formControlName="regularAccredationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.regularAccredationAmount" [name]="'Amount'"></app-form-control-messages>
				</div>
			</div>
		</div>
	
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Continuous Monitoring Fee :
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.regularContinuousMonitoringAmount)"
				 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
				 formControlName="regularContinuousMonitoringAmountIsRequired" [(ngModel)]="tcRuleDetails.rulesForType[1].continuousMonitoring.isPaymentRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.regularContinuousMonitoringAmountIsRequired"
				  [name]="'Option'"></app-form-control-messages>
	
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[1].continuousMonitoring.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
					 placeholder="Enter the amount needs to be paid" formControlName="mobileNumber" [(ngModel)]="tcRuleDetails.rulesForType[1].continuousMonitoring.amount"
					 formControlName="regularContinuousMonitoringAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.regularContinuousMonitoringAmount" [name]="'Amount'"></app-form-control-messages>
				</div>
			</div>
		</div>
	
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Un-Blocking Fee :
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.regularUnblockingAmount)" [disabled]="isDisabled()"
				 name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="regularUnblockingAmountIsRequired"
				 [(ngModel)]="tcRuleDetails.rulesForType[1].unBlocking.isPaymentRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.regularUnblockingAmountIsRequired"  [name]="'Option'"></app-form-control-messages>
	
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[1].unBlocking.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
					 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[1].unBlocking.amount"
					 formControlName="regularUnblockingAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.regularUnblockingAmount" [name]="'Amount'"></app-form-control-messages>
				</div>
			</div>
		</div>
	
		<div class="form-group m-form__group row">
			<label for="tp-details" class="col-4 col-form-label tc-text-align">
				Per-Job Role Affiliation Fee :
				<span class="mandatoryColor">*</span>
			</label>
			<div class="col-4">
				<select (ngModelChange)="setValidation($event, tcRuleCreationForm.controls.regularAffilationAmount)" [disabled]="isDisabled()"
				 name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="regularAffilationAmountIsRequired"
				 [(ngModel)]="tcRuleDetails.rulesForType[1].perJobRoleAffiliation.isPaymentRequired">
					<option value="" disabled>Select Payment Required or Not</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				<app-form-control-messages [control]="tcRuleCreationForm.controls.regularAffilationAmountIsRequired"  [name]="'Option'"></app-form-control-messages>
	
			</div>
			<div class="col-4 row" *ngIf="tcRuleDetails.rulesForType[1].perJobRoleAffiliation.isPaymentRequired=='Yes'">
				<div class="col-1 col-form-label">Rs.</div>
				<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
					 placeholder="Enter the amount needs to be paid" [(ngModel)]="tcRuleDetails.rulesForType[1].perJobRoleAffiliation.amount"
					 formControlName="regularAffilationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					 maxlength="8" minlength="0" min="0">
					<app-form-control-messages [control]="tcRuleCreationForm.controls.regularAffilationAmount" [name]="'Amount'"></app-form-control-messages>
				</div>
			</div>
		</div> -->
	
	
		<div class="m-portlet__foot m-portlet__foot--fit">
				<div class="form-group m-form__group m--margin-top-10 form_header">
					Actions & Notifications
				</div>
		
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Number of Block Attempts Allowed:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="1" name="mobile-number"
							placeholder="Select how many attempts are allowed if Training Partner is found 'Deemed Not Ready'" [(ngModel)]="tcRuleDetails.actionsAndNotifications.noOfBlockAttempts"
							formControlName="noOfBlockAttempts" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"  onkeypress="return event.charCode >= 48 && event.charCode <= 57  && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.noOfBlockAttempts" [message]="'Number of Block Attempts Allowed should be not more than 9'"
							[name]="'Number of Block Attempts Allowed'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Duration of Each Block (in Months):
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="2" name="mobile-number"
							placeholder="Select Duration of Each Block" [(ngModel)]="tcRuleDetails.actionsAndNotifications.durationOfBlock" formControlName="durationOfBlock"
							oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.durationOfBlock" [message]="'Number of Block Allowed should be not more than 12'"
							[name]="'Duration of Each Block'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Number of Days in advance Inspection notifications should be sent:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="3" name="mobile-number"
							placeholder="Select No.of Days in advance Inspection notifications should be sent" [(ngModel)]="tcRuleDetails.actionsAndNotifications.noOfDaysInAdvanceInspectionDateNotifications"
							formControlName="noOfDaysInAdvanceInspectionDateNotifications" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.noOfDaysInAdvanceInspectionDateNotifications" [message]="'Number of Days should be not more than 365'"
							[name]="'Number of Days'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						After status"Deemed Ready",No.of Days for ON-site Inspection:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="2" name="mobile-number"
							placeholder="Select after Status Updated to Deemed Ready , how many No.of days for ON-site Inspection to be Performed"
							[(ngModel)]="tcRuleDetails.actionsAndNotifications.noOfDaysForOnsiteInspectionAfterDeemedReady" formControlName="noOfDaysForOnsiteInspectionAfterDeemedReady"
							oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.noOfDaysForOnsiteInspectionAfterDeemedReady" [message]="'Number of Days should be not more than 30'"
							[name]=" 'Number of Days'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]=" 'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row" style="margin-bottom: 18px">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Maximum No.of Days for Inspection Agency reply back on assessment:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="2" name="mobile-number
						   " placeholder="Select after how many No.of days for Inspection Agency reply back on assessment" [(ngModel)]="tcRuleDetails.actionsAndNotifications.noOfDaysForInspectionAgencyReplyBackOnAssessment
						   " formControlName="noOfDaysForInspectionAgencyReplyBackOnAssessment" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.noOfDaysForInspectionAgencyReplyBackOnAssessment
						   " [message]="'Number of Days should be not more than 10'" [name]=" 'Number of Days'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]=" 'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
			</div>
		
			<div class="m-portlet__foot m-portlet__foot--fit">
				<div class="form-group m-form__group m--margin-top-10 form_header">
					Payment Refund Rules :
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Refund %age on refusal of Centre Inspection(1 week before inspection date):
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="3" name="mobile-number
						   " placeholder="Select Refund Percentage on refusal of Centre Inspection(1 week before inspection date)" [(ngModel)]="tcRuleDetails.refundRules.percentageOnRefusalOfCenterInspection[0].percentage"
							formControlName="percentageOnRefusalOfCenterInspection" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="5" minlength="1" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.percentageOnRefusalOfCenterInspection" [name]="
							'Refund percentage'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]=" 'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Refund %age on refusal of Centre Inspection(3 week before inspection date):
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number" placeholder="Select Refund Percentage on refusal of Centre Inspection(3 week before inspection date)"
							[(ngModel)]="tcRuleDetails.refundRules.percentageOnRefusalOfCenterInspection[1].percentage" formControlName="percentageOnRefusalOfCenterInspection1"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="5" minlength="1" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.percentageOnRefusalOfCenterInspection1" [name]="'Refund percentage'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]=" 'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Refund %age on refusal of Centre Inspection(on Inspection date):
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number
						   " placeholder="Select Refund Percentage on refusal of Centre Inspection(on inspection date)" [(ngModel)]="tcRuleDetails.refundRules.percentageOnRefusalOfCenterInspection[2].percentage"
							formControlName="percentageOnRefusalOfCenterInspection2"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="5" minlength="1" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.percentageOnRefusalOfCenterInspection2" [name]="
							'Refund percentage'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]=" 'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Refund %age on DNR, if Training Centre doesn't reapply:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number
						   " placeholder="Refund Percentage on DNR, if Training Centre doesn 't reapply" [(ngModel)]="tcRuleDetails.refundRules.refundOnDNRIfTCDoesnotReapply"
							formControlName="refundOnDNRIfTCDoesnotReapply"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="5" minlength="1" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.refundOnDNRIfTCDoesnotReapply" [name]="'Refund percentage '"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc '"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Refund %age on Second DNR, if Training Centre doesn't reapply:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number" placeholder="Refund Percentage on Second DNR, if Training Centre doesn't reapply"
							[(ngModel)]="tcRuleDetails.refundRules.refundOnSecondDNRIfTCDoesnotReapply" formControlName="refundOnSecondDNRIfTCDoesnotReapply"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="5" minlength="1" min="0">
						<app-form-control-messages [control]="tcRuleCreationForm.controls.refundOnSecondDNRIfTCDoesnotReapply" [name]="'Refund percentage'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tcRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
			</div>
		<br>
		<div class="m-portlet__foot m-portlet__foot--fit">
			<div class="form-group m-form__group row" style="margin-top: 18px;">
				<label class="col-xl-4 col-lg-4 col-form-label">
					Rule Setup Effective Date
					<span class="mandatoryColor">*</span>
				</label>
				<div class="col-xl- col-lg-8">
					<div class="input-group date">
						<input [disabled]="isDisabled()" (blur)="tcRuleDetails.effectiveDate = startDate.value" type="text" class="form-control m-input"
						 readonly formControlName="effectiveDate" id="startDate" placeholder="Pick your Date" [(ngModel)]="tcRuleDetails.effectiveDate"
						 #startDate />
						<div class="input-group-append">
							<span class="input-group-text">
								<i class="la la-calendar"></i>
							</span>
						</div>
					</div>
					<app-form-control-messages [control]="tcRuleCreationForm.controls.effectiveDate" [name]="'Effective date'"></app-form-control-messages>
				</div>
			</div>
		</div>
		<br>
		<!-- <div class="m-portlet__foot m-portlet__foot--fit" *ngIf=false> -->
		<!-- <div class="m-portlet__foot m-portlet__foot--fit" *ngIf="isAdmin">
		<div [formgr] class="form-group m-form__group row">
		  <label for="tp-details" class="col-4 col-form-label tc-text-align">
			Review Comments
		  </label>
		  <div class="col-8">
			<div>
			  <label class="m-checkbox">
				<input type="checkbox" [(ngModel)]="approved" (click)="notApproved=false;approved=true" [ngModelOptions]="{standalone: true}"> Approved
				<span></span>
			  </label>
			</div>
			<div>
			  <label class="m-checkbox">
				<input type="checkbox" [(ngModel)]="notApproved" (click)="approved=false;notApproved=true" [ngModelOptions]="{standalone: true}"> Not Approved
				<span></span>
			  </label>
			</div>
			<div>
			  <input class="form-control m-input" type="text" placeholder="Enter comments" formControlName="comments" [(ngModel)]="comments">
			</div>
		  </div>
		</div>
	  </div> -->
		<div *ngIf="isAdmin" class="m-portlet__foot m-portlet__foot--fit">
			<div [formGroup]="adminFormGroup" class="form-group m-form__group row">
				<label for="tp-details" class="col-4 col-form-label tc-text-align">
					Review Comments
				</label>
				<div class="col-8">
					<div>
						<label class="m-checkbox">
							<input type="checkbox" [(ngModel)]="approved" (click)="approve(true)" [ngModelOptions]="{standalone: true}">
							Approved
							<span></span>
						</label>
					</div>
					<div>
						<label class="m-checkbox">
							<input type="checkbox" [(ngModel)]="notApproved" (click)="approve(false)" [ngModelOptions]="{standalone: true}">
							Not Approved
							<span></span>
						</label>
					</div>
					<div>
						<textarea class="form-control m-input" placeholder="Enter your comments" [(ngModel)]="comments" formControlName="comments"></textarea>
					</div>
				</div>
			</div>
		</div>
		<div class="m-portlet__foot m-portlet__foot--fit">
			<div class="m-form__actions">
				<div class="row">
					<div class="col-2"></div>
					<div class="col-10 text-Centre">
						<button type="button" class="btn btn-next" (click)="saveRule()" [disabled]="!tcRuleCreationForm.valid || !adminFormGroup.valid">
							Submit
						</button>
						<button type="button" class="btn btn-next" (click)="navigateToDashboard()">
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>
	
	
	
	
	<div class="modal fade" id="trainingcenter_type_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	 aria-hidden="true">
		<form [formGroup]='tcTypeFormGroup' class="m-form m-form--fit m-form--label">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">
								Add Another Training Centre Type
						</h5>
						<button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">
								&times;
							</span>
						</button>
					</div>
					<div class="modal-body">
							<div class="row">
									<h5 class="" id="exampleModalLabel">
											Create a Training Centre Type
										</h5>
										</div>
						<div class="form-group  row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Training Centre Type
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-9">
								<input class="form-control m-input" type="text" name="mobile-number" placeholder="Enter the Name of the User type"
								 [(ngModel)]="rulesForType.type" formControlName="type">
								<app-form-control-messages [control]="tcTypeFormGroup.controls['type']" [name]="'Type'"></app-form-control-messages>
	
							</div>
						</div>
						<div class="form-group row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Accreditation Fee:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-4">
								<select [disabled]="isDisabled()" (ngModelChange)="setValidation($event, tcTypeFormGroup.controls['accredationAmount'])"
								 name="trainingCentre" class="form-control m-input" id="exampleSelect1" [(ngModel)]="rulesForType.accredation.isPaymentRequired"
								 formControlName="accredationAmountIsRequired">
									<option value="" disabled>Select Payment Required or Not</option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>
								<app-form-control-messages [control]="tcTypeFormGroup.controls['accredationAmountIsRequired']" [name]="'Option'"></app-form-control-messages>
							</div>
							<div class="col-4 row" *ngIf="rulesForType.accredation.isPaymentRequired=='Yes'">
								<div class="col-1 col-form-label">Rs.</div>
								<div class="col-9">
									<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number"
									 placeholder="Amount" [(ngModel)]="rulesForType.accredation.amount" formControlName="accredationAmount"
									 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
									 maxlength="8" minlength="0" min="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45">
									<app-form-control-messages [control]="tcTypeFormGroup.controls['accredationAmount']" [name]="'Amount'"></app-form-control-messages>
	
								</div>
							</div>
						</div>
	
						<div class="form-group row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Continuous Monitoring Fee :
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-4">
								<select (ngModelChange)="setValidation($event, tcTypeFormGroup.controls['continuousMonitoringAmount'])"
								 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
								 formControlName="continuousMonitoringAmountIsRequired" [(ngModel)]="rulesForType.continuousMonitoring.isPaymentRequired">
									<option value="" disabled>Select Payment Required or Not</option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>
								<app-form-control-messages [control]="tcTypeFormGroup.controls['continuousMonitoringAmountIsRequired']" [name]="'Option'"></app-form-control-messages>
							</div>
							<div class="col-4 row" *ngIf="rulesForType.continuousMonitoring.isPaymentRequired=='Yes'">
								<div class="col-1 col-form-label">Rs.</div>
								<div class="col-9">
									<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
									 placeholder="Amount" formControlName="continuousMonitoringAmount" [(ngModel)]="rulesForType.continuousMonitoring.amount"
									 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
									 maxlength="8" minlength="0"  min="0"  onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45">
									<app-form-control-messages [control]="tcTypeFormGroup.controls['continuousMonitoringAmount']" [name]="'Amount'"></app-form-control-messages>
								</div>
							</div>
						</div>
	
						<div class="form-group row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Un-Blocking Fee:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-4">
								<select (ngModelChange)="setValidation($event, tcTypeFormGroup.controls['unblockingAmount'])" [disabled]="isDisabled()"
								 name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="unblockingAmountIsRequired"
								 [(ngModel)]="rulesForType.unBlocking.isPaymentRequired">
									<option value="" disabled>Select Payment Required or Not</option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>
								<app-form-control-messages [control]="tcTypeFormGroup.controls['unblockingAmountIsRequired']" [name]="'Option '"></app-form-control-messages>
							</div>
							<div class="col-4 row" *ngIf="rulesForType.unBlocking.isPaymentRequired=='Yes'">
								<div class="col-1 col-form-label">Rs.</div>
								<div class="col-9">
									<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
									 placeholder="Amount" [(ngModel)]="rulesForType.unBlocking.amount" formControlName="unblockingAmount"
									 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
									 maxlength="8" minlength="0"  min="0"  onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45">
									<app-form-control-messages [control]="tcTypeFormGroup.controls['unblockingAmount']" [name]="'Amount'"></app-form-control-messages>
								</div>
							</div>
						</div>
	
						<div class="form-group  row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Per-Job Role Affiliation Fee :
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-4">
								<select (ngModelChange)="setValidation($event, tcTypeFormGroup.controls['affilationAmount'])" [disabled]="isDisabled()"
								 name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="affilationAmountIsRequired"
								 [(ngModel)]="rulesForType.perJobRoleAffiliation.isPaymentRequired">
									<option value="" disabled>Select Payment Required or Not</option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>
								<app-form-control-messages [control]="tcTypeFormGroup.controls['affilationAmountIsRequired']" [name]="'Option'"></app-form-control-messages>
							</div>
							<div class="col-4 row" *ngIf="rulesForType.perJobRoleAffiliation.isPaymentRequired=='Yes'">
								<div class="col-1 col-form-label">Rs.</div>
								<div class="col-9">
									<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
									 placeholder="Amount" [(ngModel)]="rulesForType.perJobRoleAffiliation.amount"
									 formControlName="affilationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
									 maxlength="8" minlength="0"  min="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45">
									<app-form-control-messages [control]="tcTypeFormGroup.controls['affilationAmount']" [name]="'Amount'"></app-form-control-messages>
	
								</div>
							</div>
						</div>

						<div class="form-group  row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Appeal Fee :
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-4">
								<select (ngModelChange)="setValidation($event, tcTypeFormGroup.controls['appealAmount'])" [disabled]="isDisabled()"
									name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="appealAmountIsRequired"
									[(ngModel)]="rulesForType.appeal.isPaymentRequired">
									<option value="" disabled>Select Payment Required or Not</option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>
								<app-form-control-messages [control]="tcTypeFormGroup.controls['appealAmountIsRequired']" [name]="'Option'"></app-form-control-messages>
							</div>
							<div class="col-4 row" *ngIf="rulesForType.appeal.isPaymentRequired=='Yes'">
								<div class="col-1 col-form-label">Rs.</div>
								<div class="col-9">
									<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
										placeholder="Amount" [(ngModel)]="rulesForType.appeal.amount"
										formControlName="appealAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
										maxlength="8" minlength="0"  min="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45">
									<app-form-control-messages [control]="tcTypeFormGroup.controls['appealAmount']" [name]="'Amount'"></app-form-control-messages>

								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">
							Close
						</button>
						<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="addToRuleForType()" [disabled]='!tcTypeFormGroup.valid'>
							Save & Submit
						</button>
					</div>
				</div>
				<!-- </div> -->
			</div>
		</form>
	</div>
	